import { _ } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

export interface AppMenuItem extends MenuItem {
  permission?: string;
  items?: AppMenuItem[];
  dashboard?: {
    descriptionKey: string;
    buttonKey: string;
  };
}

export const menuItems: AppMenuItem[] = [
  {
    label: 'label.start',
    routerLink: '/start',
    icon: 'fa-regular fa-home',
  },
  {
    label: 'label.menuDiscover',
    icon: 'fa-regular fa-location-dot',
    expanded: true,
    items: [
      {
        label: 'label.discoverMap',
        routerLink: '/discover',
        icon: 'fa-regular fa-map-location-dot',
        permission: 'manage:sites',
        // `/discover` is a prefix of every other discover route, and PanelMenu matches
        // non-exactly by default — so without this the map entry would also light up on the
        // sites list and on a site's detail page, marking two destinations at once.
        routerLinkActiveOptions: { exact: true },
        dashboard: {
          descriptionKey: 'discover.map.description',
          buttonKey: 'discover.map.button',
        },
      },
      {
        label: 'label.discoverSites',
        routerLink: '/discover/sites',
        icon: 'fa-regular fa-table-list',
        dashboard: {
          descriptionKey: 'discover.sites.description',
          buttonKey: 'discover.sites.button',
        },
      },
    ],
  },
  {
    label: 'label.menuAdmin',
    icon: 'fa-regular fa-gear',
    expanded: true,
    items: [
      {
        label: 'label.editUsers',
        routerLink: '/users',
        icon: 'fa-regular fa-users',
        permission: 'manage:users',
        dashboard: {
          descriptionKey: 'startPage.users.description',
          buttonKey: 'startPage.users.button',
        },
      },
    ],
  },
];

export const menuLabels = _([
  'label.start',
  'label.menuAdmin',
  'label.menuDiscover',
  'label.discoverMap',
  'label.discoverSites',
  'label.editUsers',
  'startPage.users.description',
  'startPage.users.button',
  'discover.map.description',
  'discover.map.button',
  'discover.sites.description',
  'discover.sites.button',
]);
